import Vue from "vue";
import VueRouter from "vue-router";

import { routes } from "./routerPath.js";
import { Message } from "element-ui";

/*
router重复点击报错过滤
*/
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash",
  base: "/admin/",
  routes,
});
/*
存储需要过滤的隐藏菜单
*/
const routerPathOutRole = [
  "/login", //登录
  "/admin", //主页
  "/setPassword", //设置密码
  "/examManag/registerExam/registerInfo", //课程管理->报名详情
  "/examManag/processManag/examInfo", //考试过程管理->考试详情
  "/examManag/processManag/offExamInfo", //考试过程管理->线下考试详情
  "/examManag/processManag/theoryInfo", //考试过程管理->理论考试详情
  "/examManag/processManag/theoryInfo/studentExamPaper", //考试过程管理->理论考试详情->查看试卷
  "/examManag/processManag/arrangeJudges", //考试过程管理->安排评委
  "/examManag/examArrangement/examArrangementInfo", //线下考试安排->考试详情
  '/examManage/videoReview/videoReviewInfo',//考试信息管理->考生视频审核->审核详情
  '/examManag/testGroupPaper/formalExamination',// 理论考试组卷->正式考试
  '/examManag/testGroupPaper/practiceTest',// 理论考试组卷->模拟考试
  '/information/theoryDetail',// 基础信息管理->理论考试题库->详情
  '/QRCode',//合格证查看
  '/AdCate',//准考证查看
  '/cert',//考级证书查询
];
/*
判断当前用户是否有此菜单权限
默认过滤以上菜单
有-> 跳转
无-> 跳到默认后台页面
*/
router.beforeEach((to, from, next) => {
  if (
    routerPathOutRole.some((item) => {
      return item == to.path;
    })
  ) {
    next();
  } else {
    try {
      let vuex = sessionStorage.getItem("vuex");
      let mentForUser = JSON.parse(vuex).menu.mentForUser;
      if (
        mentForUser.some((item) => {
          return item == to.path;
        })
      ) {
        next();
      } else {
        next();
      }
    } catch (error) {
      // Message({ type: "warning", message: "用户未登录!" });
      next("/login");
    }
  }
});

export default router;
